import {Checkbox, FormControlLabel, useTheme} from '@mui/material';
import React from 'react';
import {ControlledCheckboxProps} from './types';

const ControlledCheckbox = ({
	checked,
	handleCheck,
	label,
	fontWeight,
	customColor,
	paddingLeft,
}: ControlledCheckboxProps) => {
	const {colors} = useTheme();

	return (
		<FormControlLabel
			control={<Checkbox sx={{height: 42, width: 42}} />}
			onChange={handleCheck}
			checked={checked}
			slotProps={{
				typography: {
					sx: {
						fontSize: '0.875rem',
						color: customColor ?? colors.light.text.primary,
						userSelect: 'none',
						pl: paddingLeft,
						fontWeight,
					},
				},
			}}
			label={label}
		/>
	);
};

export {ControlledCheckbox};
